export default __webpack_public_path__ + "static/media/group-1192.96a76a11.png";